var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformBlockquote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 11,
  viewBox: "0 0 14 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 7.2c0 2.352 1.392 3.648 2.976 3.648a2.58 2.58 0 0 0 2.592-2.592c0-1.392-1.008-2.448-2.352-2.448-.24 0-.576.096-.624.096.192-1.536 1.536-3.456 3.072-4.464L3.888 0C1.68 1.536 0 4.272 0 7.2m7.68 0c0 2.352 1.392 3.648 2.976 3.648a2.58 2.58 0 0 0 2.592-2.592c0-1.392-1.008-2.448-2.352-2.448-.192 0-.528.096-.624.096.192-1.536 1.536-3.456 3.072-4.464L11.568 0C9.36 1.536 7.68 4.272 7.68 7.2"
})));
export default SvgLongformBlockquote;